export default "__VITE_ASSET__D$0CaRs$__"